module.exports = __webpack_public_path__ + "static/fireglass-ab9af121bd57087db9d6bbcb055adcb0.svg";